export function parseTasks(task) {
    let { completedByName, desc,deadline, deadlineInString, title, taskType, isCompleted, completedOn, isReminderSent } = task;

    let completedOnString;
    if (isCompleted && completedOn) {
        let date = new Date(completedOn._seconds * 1000);
        completedOnString =
            date.toDateString().split(" ").slice(1).join(" ") + " - " + date.toTimeString().split(" ")[0];
    }

    let detail;
    let detailString;

    if (taskType === "memberLicenseExpiry") {
        detail = `License Expiry for ${task.metaData.name} ${task.metaData.licenceid}`;
        detailString = detail;
    } else {
        detail = desc;
        detailString = desc;
    }

    if (!completedOn) completedOn = "-";
    if (!completedByName) completedByName = "-";

    if (isCompleted === false) {
        completedByName = "-";
        completedOnString = "-";
    }

    let taskData = {
        completedByName,
        deadlineInString,
        title,
        detail,
        detailString,
        isReminderSent: isReminderSent ? "Yes" : "No",
        completedOnString,
        isCompleted,
        deadline : deadline._seconds
    };

    return taskData;
}
